import React from "react";
import InfoSection from "../InfoSection/InfoSection";
import { useGameStateStore } from "../../../stores/gameStateStore";


export default function Countdown() {
  const roundStatus = useGameStateStore(s => s.roundStatus)
  const countdown = useGameStateStore(s => s.countdown);

  return (
    <InfoSection
      text={`00:${countdown < 10 ? "0" : ""}${countdown}`}
      textClassName={roundStatus === "waiting" ? "green-text" : "red-text"}
      className="fa fa-clock"
    />
  )
}